import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import type { RootState, AppDispatch } from 'store';

export { default as userHasRequiredPermissions } from './useUserPermissions';
export { useCurrency } from './useCurrency';
export type { CurrencyConfig, UseCurrencyReturn } from './useCurrency';

export const useAppDispatch = (): AppDispatch => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
